import { render, staticRenderFns } from "./hotImg.vue?vue&type=template&id=74ae6054&scoped=true&"
import script from "./hotImg.vue?vue&type=script&lang=js&"
export * from "./hotImg.vue?vue&type=script&lang=js&"
import style0 from "./hotImg.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./hotImg.vue?vue&type=style&index=1&id=74ae6054&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ae6054",
  null
  
)

component.options.__file = "hotImg.vue"
export default component.exports